import { ReactNode } from 'react';
import { AlertTriangle, CheckCircle2, Flame, Info } from 'lucide-react';
import { cn } from '@/shared/utils/utils';

export type BriefingTone = 'pos' | 'warn' | 'info' | 'neg';

export interface BriefingLine {
  text: ReactNode;
  tone: BriefingTone;
}

const TONE_STYLE: Record<BriefingTone, { icon: typeof Info; className: string; bg: string }> = {
  pos: { icon: CheckCircle2, className: 'text-success-text', bg: 'bg-success/10' },
  warn: { icon: AlertTriangle, className: 'text-warning-text', bg: 'bg-warning/10' },
  info: { icon: Info, className: 'text-primary', bg: 'bg-primary/10' },
  neg: { icon: Flame, className: 'text-danger-text', bg: 'bg-danger/10' },
};

export function Briefing({ headline, lines, className }: { headline?: ReactNode; lines: BriefingLine[]; className?: string }) {
  return (
    <div className={cn('flex flex-col gap-3.5', className)}>
      {headline && <p className="text-data-md leading-relaxed text-on-surface-variant">{headline}</p>}
      <div className="flex flex-col gap-2">
        {lines.map((line, i) => {
          const { icon: Icon, className: iconClass, bg } = TONE_STYLE[line.tone];
          return (
            <div key={i} className={cn('flex items-start gap-2.5 rounded-card px-3 py-2.5', bg)}>
              <Icon className={cn('mt-0.5 h-4 w-4 shrink-0', iconClass)} />
              <span className="text-body-md leading-relaxed text-on-surface-variant">{line.text}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
